import * as React from 'react';

const Modal = require('react-responsive-modal');

interface Props {
    gridParams: any;
    modalRef: any;
    readOnly: boolean;
    focusTrapped?: boolean
}

interface State {
    isOpen: boolean;
}

class TextAreaModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false
        };
        props.modalRef.current = this;
    }

    componentDidMount(): void {
        document.addEventListener('keydown', this.textAreaKeyListener);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.textAreaKeyListener);
    }

    textAreaKeyListener = (e) => {
        if (e.code === 'Escape') {
            this.close();
        }
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    getValue = () => {
        if (this.props.gridParams?.strValue) {
            return this.props.gridParams.strValue
        } else if (this.props.gridParams && !this.props.gridParams.strValue) {
            return this.props.gridParams.value.trim()
        } else {
            return ''
        }
    }

    render() {
        const {gridParams} = this.props;
        return (
            <Modal
                open={this.state.isOpen}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: '60%',
                        padding: 0,
                        maxWidth: '60%',
                        background: "transparent",
                    },
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={this.props.focusTrapped ? this.props.focusTrapped : false}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%'}}
                     className={"container-fluid"}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'text-area-container'} className='col-lg-12 compare-changes'>
                            <h4 style={{color: 'rgb(195 195 195)'}}>{gridParams ? gridParams.colDef.headerName : ''}</h4>
                            <textarea style={{width: '100%', height: 'calc(100vh - 460px)', minHeight: 300, resize: "none", fontFamily: 'monospace', fontSize: 14}}
                                      id='text-area-navigator'
                                      defaultValue={this.getValue()}
                                      className={'text-area-for-edit'}
                                      readOnly={this.props.readOnly}
                            />
                            <button
                                onClick={this.close}
                                className={"btn"}
                                id={'close-modal-btn'}
                                style={{float: "right", marginTop: 3}}>
                                <i className="fas fa-times"> Close</i>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default TextAreaModal



// WEBPACK FOOTER //
// ./app/components/common/TextAreaModal/TextAreaModal.tsx